import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import styled from 'styled-components';
import { getAuthorByName } from '@/data/authors';

interface IProps {
  authorName: string;
}

export const AuthorBlock = ({ authorName }: IProps) => {
  const author = getAuthorByName(authorName);
  if (!author) return null;

  return (
    <Wrapper>
      <PhotoLink href={`/blog/authors/${author.slug}`} aria-label={author.name}>
        <Photo
          src={author.photo}
          alt={author.name}
          width={88}
          height={88}
          sizes="44px"
        />
      </PhotoLink>
      <Byline>
        <ByPrefix>By:</ByPrefix>
        <NameLink href={`/blog/authors/${author.slug}`}>{author.name}</NameLink>
      </Byline>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 12px 0 0;
`;

const PhotoLink = styled(Link)`
  flex-shrink: 0;
  display: block;
  width: 44px;
  height: 44px;
  overflow: hidden;
  border-radius: 50%;
`;

const Photo = styled(Image)`
  object-fit: cover;
  width: 100% !important;
  height: 100% !important;
`;

const Byline = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
  font-family: var(--font-roboto, system-ui, sans-serif);
  font-size: 14px;
  line-height: 1.35;
`;

const ByPrefix = styled.span`
  color: #757575;
  font-weight: 400;
`;

const NameLink = styled(Link)`
  font-weight: 500;
  color: var(--accent-bg);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
